(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-cart-bar"]) return;
  try {
    
  if (!customElements.get('sk-cart-bar')) {
    customElements.define('sk-cart-bar', class extends HTMLElement {
      connectedCallback() {
        this._none = this.dataset.threshold === '0';
        this._t = parseInt(this.dataset.threshold, 10) || 2900;
        this._onChange = () => this.refresh();
        window.addEventListener('sk:cart-changed', this._onChange);
        window.addEventListener('sk-plant-freight:cart', this._onChange);
        document.addEventListener('shopify:cart:lines-update', this._onEvt = (e) => {
          if (e.promise && e.promise.then) e.promise.then(this._onChange).catch(() => {});
        });
      }
      disconnectedCallback() {
        window.removeEventListener('sk:cart-changed', this._onChange);
        window.removeEventListener('sk-plant-freight:cart', this._onChange);
        if (this._onEvt) document.removeEventListener('shopify:cart:lines-update', this._onEvt);
      }
      money(cents) {
        return (cents / 100).toFixed(2).replace('.', ',') + ' €';
      }
      refresh() {
        fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then((r) => r.json())
          .then((cart) => {
            const total = cart.total_price;
            let off = false;
            const pf = window.skPlantFreight;
            if (pf && typeof pf.split === 'function') {
              try { off = !!pf.split(cart).onlyFreight; } catch (_) {}
            }
            this.hidden = off || this._none;
            const pct = Math.min(100, Math.round((total / this._t) * 100));
            const fill = this.querySelector('[data-sk-cart-bar-fill]');
            if (fill) fill.style.width = pct + '%';
            this.classList.toggle('sk-cart-bar--achieved', total >= this._t);
            const text = this.querySelector('[data-sk-cart-bar-text]');
            if (!text) return;
            text.textContent = '';
            if (total >= this._t) {
              const s = document.createElement('strong');
              s.textContent = this.dataset.tAchieved;
              text.appendChild(s);
            } else {
              const s = document.createElement('strong');
              s.textContent = this.money(this._t - total);
              text.append(this.dataset.tPrefix + ' ', s, ' ' + this.dataset.tSuffix);
            }
          })
          .catch(() => {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(min-width: 769px)');
    function sync() {
      document.querySelectorAll('[data-sk-footer] .skf__col').forEach(function (d) {
        d.open = mq.matches;
      });
    }
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);
  })();

  } catch(e) { console.error(e); }
})();
})();
